
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /*
| Developed by Dirupt
| Filename : verify.tsx
| Author : Philippe DESPLATS (philippe@dirupt.com)
*/
import React from 'react';
import { Box, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { m } from 'framer-motion';
import { LinkProps as NextLinkProps } from 'next/dist/client/link';
import { Senskle } from '@/components/common/svgs/logo/Senskle';
import { SensklePageFactory } from '@/components/ssr/SensklePage';
import { createAuthServerSideProps } from '@/components/ssr/createServerSideProps';
import { MButton } from '@/components/common/MButton';
import { MotionContainer, variantFade } from '@/components/animate';
import { RouterLink } from '@/components/common/MLink';
import { UrlsConfig } from '@/config/urls.config';
/*
|--------------------------------------------------------------------------
| Page
|--------------------------------------------------------------------------
*/
const BetaRestricted = SensklePageFactory(() => {
    const { t } = useTranslation();
    return (<Box display={'flex'} flexDirection={'column'} justifyContent={'center'} gap={4} width={'100%'} minHeight={'calc(100vh - 32px)'} component={MotionContainer}>
			<Box paddingBottom={4} textAlign={'center'} component={m.div} variants={variantFade().inLeft}>
				<Senskle sx={{ width: '100%', height: 'fit-content', maxWidth: '170px', margin: '0 auto' }}/>
			</Box>
			<Box textAlign={'center'} component={m.div} variants={variantFade().inLeft}>
				<Typography variant={'h1'}>{t('auth/beta-restricted:title')}</Typography>
				<Typography>{t('auth/beta-restricted:subTitle')}</Typography>
			</Box>
			<Box display={'flex'} flexDirection={'column'} justifyContent={'center'} gap={1} component={m.div} variants={variantFade().inLeft}>
				<MButton variant="contained" size={'large'} component={RouterLink} href={UrlsConfig.auth.createAccount}>
					{t('auth/beta-restricted:cta.register')}
				</MButton>
				<MButton<NextLinkProps & {
        target: string;
    }> variant="outlined" size={'large'} component={RouterLink} href={UrlsConfig.external.website} target={'_blank'}>
					{t('auth/beta-restricted:cta.goToWebsite')}
				</MButton>
			</Box>
		</Box>);
});
/*
|--------------------------------------------------------------------------
| Configurations
|--------------------------------------------------------------------------
*/
BetaRestricted.layout = 'empty';
export default BetaRestricted;
/*
|--------------------------------------------------------------------------
| Server Side Props
|--------------------------------------------------------------------------
*/
const getServerSideProps = createAuthServerSideProps();

    async function __Next_Translate__getServerSideProps__1a09ebd47c9__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/auth/beta-restricted',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a09ebd47c9__ as getServerSideProps }
  